import React, { useState, useEffect, useCallback } from "react";
import { Tabs, Button, Space } from "antd";
import { AppstoreOutlined, ControlOutlined, PlusOutlined } from "@ant-design/icons";
import { TechCardContext } from "src/shared/lib/hooks/context/getTechCardsContext";
import { useLocation } from "react-router-dom";
import { apiRequests } from "src/shared/api/api";
import TableTechCards from "src/features/Table/ui/TableTechCards";
import TableTechOperations from "src/features/Table/ui/TableTechOperations";
import AddTechCardModal from "src/features/Modal/ui/AddTechCard";

export default function TableTechCardsPage({ token, websocket, initialData }) {
  const { pathname } = useLocation();
  const [data, setData]         = useState(initialData || []);
  const [loading, setLoading]   = useState(false);

  const [operations, setOperations]         = useState([]);
  const [opsLoading, setOpsLoading]         = useState(false);

  const [activeTab, setActiveTab]           = useState("cards");
  const [addCardOpen, setAddCardOpen]       = useState(false);

  const refreshData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiRequests.tech_cards.getItems({ token });
      const raw = Array.isArray(res.data) ? res.data : (res.data?.result || []);
      setData(raw.map(tc => ({
        ...tc,
        items_count:        tc.items        ? tc.items.length        : 0,
        output_items_count: tc.output_items ? tc.output_items.length : 0,
      })));
    } catch (e) {
      console.error("refreshData error:", e);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const refreshOperations = useCallback(async () => {
    setOpsLoading(true);
    try {
      const res = await apiRequests.tech_operations.getItems({ token });
      const raw = Array.isArray(res.data) ? res.data : (res.data?.result || []);
      setOperations(raw);
    } catch (e) {
      console.error("refreshOperations error:", e);
    } finally {
      setOpsLoading(false);
    }
  }, [token]);

  useEffect(() => { if (token) refreshData(); }, [token, refreshData]);

  useEffect(() => {
    if (token && activeTab === "operations") refreshOperations();
  }, [token, activeTab, refreshOperations]);

  const tabItems = [
    {
      key:   "cards",
      label: (
        <Space>
          <AppstoreOutlined />
          Тех. карты
        </Space>
      ),
      children: (
        <TableTechCards />
      ),
    },
    {
      key:   "operations",
      label: (
        <Space>
          <ControlOutlined />
          Тех. операции
        </Space>
      ),
      children: (
        <TableTechOperations
          operations={operations}
          loading={opsLoading}
          token={token}
          onRefresh={refreshOperations}
        />
      ),
    },
  ];

  return (
    <TechCardContext.Provider
      value={{ token, data, loading, pathname, websocket, refreshData }}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        tabBarExtraContent={
          activeTab === "cards" && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setAddCardOpen(true)}
            >
              Добавить тех. карту
            </Button>
          )
        }
        items={tabItems}
        style={{ padding: "0 8px" }}
      />

      <AddTechCardModal
        isOpen={addCardOpen}
        setOpen={setAddCardOpen}
        onSuccess={refreshData}
        refreshData={refreshData}
      />
    </TechCardContext.Provider>
  );
}